<div class="max-w-md mx-auto flex flex-col mt-4 relative overflow-hidden">
  <div class="flex justify-center item-center mt-10 mb-2">
    <h6 class="text-2xl font-semibold text-gray-800">
      Create a new
      <span class="italic">Error Message</span>
      for
      <br />
      <span class="text-amazone-orange">{{ swPartNumber }}</span>
    </h6>
  </div>

  <form [formGroup]="errorMessageForm">
    <div class="max-w-sm mx-auto mt-4 overflow-y-auto h-[calc(100vh-12rem)] px-4">
      <div class="mb-3">
        <app-text-area
          [fieldIsRequired]="true"
          [fieldConfigurationAddress]="'errormessage.headerOnTerminal'"
          [label]="'This is the header of the error message, which will be displayed on the terminal'"
          [formControl]="headerOnTerminal"
          [placeholder]="'Header on Terminal'"
          [rows]="1"
          [borderColorClass]="'border-terminal-field focus:ring-terminal-field focus:border-terminal-field'"
          [displayChangeIndicator]="false"
        ></app-text-area>
      </div>
      <app-text-area
        [label]="'This is the detail-text of the error message, which will be displayed on the terminal'"
        [placeholder]="'Details on Terminal'"
        [fieldConfigurationAddress]="'errormessage.detailsOnTerminal'"
        [fieldIsRequired]="false"
        [formControl]="detailsOnTerminal"
        [borderColorClass]="'border-terminal-field focus:ring-terminal-field focus:border-terminal-field'"
        [displayChangeIndicator]="false"
      >
      </app-text-area>
      <div class="w-full mt-5">
        <app-label-with-help for="category" class="primary-label" fieldConfigurationAddress="errormessage.category"
          >Category</app-label-with-help
        >
      </div>
      <div class="inline-flex mb-5">
        <app-selection
          [formControl]="errorCategory"
          [options]="errorCategories"
          [invalidOption]="errorCategories[0].id"
        ></app-selection>
      </div>
      <app-dtc-value-list></app-dtc-value-list>
      <div class="inline-flex items-center justify-center w-full">
        <hr class="w-64 h-px my-8 bg-gray-200 border-0" />
        <span class="absolute px-3 font-normal text-gray-500 -translate-x-1/2 bg-white left-1/2">optional</span>
      </div>
      <div class="col-span-full pt-4">
        <app-text-area
          [label]="'Internal notes'"
          [fieldConfigurationAddress]="'errormessage.internalNotes'"
          [fieldIsRequired]="false"
          [formControl]="internalNotes"
          [displayChangeIndicator]="false"
        ></app-text-area>
      </div>
      <div class="flex justify-end">
        <button
          data-tooltip-target="tooltip-generate"
          type="button"
          [disabled]="errorMessageForm.invalid"
          class="crud-btn-create"
          (click)="createErrorMessage()"
          appAgentAction
          agent="new-error-message-create"
          businessObject="errorMessage"
          action="create"
        >
          <app-floppy-icon></app-floppy-icon>
        </button>
        <div
          id="tooltip-generate"
          role="tooltip"
          class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-xs opacity-0 tooltip dark:bg-gray-700"
        >
          🫡
          <div class="tooltip-arrow" data-popper-arrow></div>
        </div>
      </div>
    </div>
  </form>
</div>
<app-propagate-created-entity-modal #propagateCreatedEntityModal></app-propagate-created-entity-modal>
